import { gql } from "@apollo/client";

const GET_USER_GROUP = gql`
  query userGroup($id: UUID!) {
    userGroup(id: $id) {
      id
      description
      isSystemGroup
      memberCount
      name
      members {
        id
        isGroupAdmin
        skynetUserId
        skynetUser {
          firstName
          lastName
          email
        }
        overrides {
          admin {
            read
            write
          }
          aml {
            read
            write
          }
          client {
            read
            write
          }
          file {
            read
            write
          }
          invoice {
            read
            write
          }
          onboarding {
            read
            write
          }
        }
      }

      permissions {
        admin {
          defaultRead
          defaultWrite
          maxRead
          maxWrite
        }
        aml {
          defaultRead
          defaultWrite
          maxRead
          maxWrite
        }
        client {
          defaultRead
          defaultWrite
          maxRead
          maxWrite
        }
        file {
          defaultRead
          defaultWrite
          maxRead
          maxWrite
        }
        invoice {
          defaultRead
          defaultWrite
          maxRead
          maxWrite
        }
        onboarding {
          defaultRead
          defaultWrite
          maxRead
          maxWrite
        }
      }
    }
  }
`;

export default GET_USER_GROUP;
